<template>
  <transition name="from-top">
    <div v-if="Object.keys(message).length !== 0" class="tol-messages">
      <tol-alert
        :message="message.text"
        :dismissable="true"
        :type="message.type"
        :update-summary="summary"
        @dismiss="onDismiss"
      >
        <template v-slot:update-alert="{ value }">
          <p v-for="(label, idx) of Object.keys(value)" :key="idx" class="message-label">
            {{ label }}
            <span v-for="(ref, refIdx) of value[label]" :key="label + refIdx">
              <router-link :to="`/` + getObjectPrefix(label) + `/${ref}`">{{ ref }} </router-link>
            </span>
          </p>
        </template>
      </tol-alert>
    </div>
  </transition>
</template>

<script>
import TolAlert from '../../components/TolAlert';
import { TolMessagesGetters, TolMessagesActions } from './tol-messages.keys';

export default {
  components: {
    TolAlert
  },
  computed: {
    message() {
      const message = this.$store.getters[TolMessagesGetters.Messages];
      return message;
    },
    summary() {
      const message = this.$store.getters[TolMessagesGetters.Messages];
      // eslint-disable-next-line no-unused-vars
      const { type, text, ...updateFields } = message;
      return { ...updateFields };
    }
  },
  methods: {
    onDismiss() {
      this.$store.dispatch(TolMessagesActions.ClearAll);
    },
    getObjectPrefix(label) {
      if (label.indexOf('time sheet') !== -1) {
        return 'time-sheets';
      }
      if (label.indexOf('expense') !== -1) {
        return 'expenses';
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import '../../styles/variables.scss';
@import '../../styles/colors.scss';

.tol-messages {
  margin-top: -$alert-vertical-margin;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
}

.message-label {
  span a {
    color: $white;
  }
}

.from-top-enter,
.from-top-leave-to {
  opacity: 0;
  top: -30px;
}
.from-top-enter-to,
.from-top-leave {
  opacity: 1;
  top: 0;
}
.from-top-enter-active,
.from-top-leave-active {
  transition: opacity 250ms, top 250ms;
}
</style>
